import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Songs
export const fetchSongs = () => api.get("/songs").then((r) => r.data);
export const createSong = (data) => api.post("/songs", data).then((r) => r.data);
export const updateSong = (id, data) => api.put(`/songs/${id}`, data).then((r) => r.data);
export const deleteSong = (id) => api.delete(`/songs/${id}`).then((r) => r.data);

// Setlists
export const fetchSetlists = () => api.get("/setlists").then((r) => r.data);
export const fetchSetlist = (id) => api.get(`/setlists/${id}`).then((r) => r.data);
export const createSetlist = (data) => api.post("/setlists", data).then((r) => r.data);
export const updateSetlist = (id, data) => api.put(`/setlists/${id}`, data).then((r) => r.data);
export const deleteSetlist = (id) => api.delete(`/setlists/${id}`).then((r) => r.data);
export const addSongToSetlist = (id, songId) =>
  api.post(`/setlists/${id}/songs`, { song_id: songId }).then((r) => r.data);
export const removeSongFromSetlist = (id, songId) =>
  api.delete(`/setlists/${id}/songs/${songId}`).then((r) => r.data);
export const reorderSetlist = (id, songIds) =>
  api.put(`/setlists/${id}/reorder`, { song_ids: songIds }).then((r) => r.data);
export const togglePlayed = (id, songId) =>
  api.post(`/setlists/${id}/played/toggle`, { song_id: songId }).then((r) => r.data);
export const resetPlayed = (id) =>
  api.post(`/setlists/${id}/played/reset`).then((r) => r.data);
export const shareSetlist = (id) =>
  api.post(`/setlists/${id}/share`).then((r) => r.data);
export const unshareSetlist = (id) =>
  api.post(`/setlists/${id}/unshare`).then((r) => r.data);
export const fetchPublicSetlist = (slug) =>
  api.get(`/public/setlists/${slug}`).then((r) => r.data);
